export const NAV_LINK_ACTIVE = 'bg-gray-800 font-semibold text-gray-100'
export const NAV_LINK_IDLE = 'text-gray-400 hover:bg-gray-800 hover:text-gray-200'
